import React from 'react'
import ReactDOM from 'react-dom'

export default class Map extends React.Component {

    constructor(props){
        super(props);
        this.samples = this.props.samples;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.google !== this.props.google || this.samples === undefined) {
            this.samples = this.props.samples;

            this.loadMap();
        }

        if (prevProps.samples){
            if (prevProps.samples.length !== this.props.samples.length) {
                this.drawSamples();
            }
            if (this.props.summary){
                this.drawSamples();
                this.drawTrees();
            }

            if (this.props.coordinates){
                if (this.props.coordinates.lat){
                    if (prevProps.coordinates.lat !== this.props.coordinates.lat) {
                        this.fly(this.props.coordinates.lat, this.props.coordinates.lng);
                        this.map.setZoom(15);
                    }
                }
            }
        }
    }

    componentDidMount() {
        if(this.samples !== undefined) {
            this.loadMap();
            this.drawSamples();
            this.drawTrees();
        }
    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillMount() {
        this.polyArray = [];
        this.treeArray = [];
        this.lastInfo = null;
    }

    loadMap() {

        const { google } = this.props;
        const maps = google.maps;

        const mapRef = this.refs.googleMap;
        const node = ReactDOM.findDOMNode(mapRef);

        const opt = this.options();

        this.map = new maps.Map(node, opt);

        this.map.setMapTypeId(google.maps.MapTypeId.HYBRID);

        if (!this.props.summary) {
            this.drawSamples()
        }

    }


    drawSamples(){

        const { google, samples } = this.props;

        this.polyArray.forEach((s)=>{
           s.setMap(null);
        });
        this.polyArray = [];

        samples.forEach((sample) => {
            let sampleArea;
            if (sample.measure_method_type === 2) {

                let easternMost
                let westernMost
                let northMost
                let southMost
                sample.trees[0].forEach(tree => {

                    if (easternMost === undefined) {
                        easternMost = tree
                        westernMost = tree
                        northMost = tree
                        southMost = tree
                    } else {
                        if (easternMost.gps_longitude < tree.gps_longitude) {
                            easternMost = tree
                        }
                        if (westernMost.gps_longitude > tree.gps_longitude) {
                            westernMost = tree
                        }
                        if (northMost.gps_latitude < tree.gps_latitude) {
                            northMost = tree
                        }
                        if (southMost.gps_latitude > tree.gps_latitude) {
                            southMost = tree
                        }
                    }
                })

                let diffHorizontal = Math.abs(
                    this.longitudeToMeter(easternMost.gps_longitude, easternMost.gps_latitude)) -
                    Math.abs(this.longitudeToMeter(westernMost.gps_longitude, westernMost.gps_latitude))

                let diffVertical = Math.abs(
                    this.latitudeToMeter(northMost.gps_latitude)) -
                    Math.abs(this.latitudeToMeter(southMost.gps_latitude))

                let firstTree = sample.trees[0][0];
                let lastTree = sample.trees[0][sample.trees[0].length -1];
                if (Math.abs(diffHorizontal) > Math.abs(diffVertical)) {
                    firstTree = easternMost
                    lastTree = westernMost
                } else {
                    if (northMost.gps_longitude > southMost.gps_longitude) {
                        firstTree = northMost
                        lastTree = southMost
                    } else {
                        firstTree = southMost
                        lastTree = northMost
                    }
                }

                // First tree east
                let diffLatitude = this.latitudeToMeter(firstTree.gps_latitude)
                    - this.latitudeToMeter(lastTree.gps_latitude)
                let diffLongitude = this.longitudeToMeter(firstTree.gps_longitude, firstTree.gps_latitude)
                    - this.longitudeToMeter(lastTree.gps_longitude, lastTree.gps_latitude)

                let shiftInLongitude = diffLatitude / diffLongitude;
                let shiftInLatitude = diffLongitude / diffLatitude;

                let totalShift = Math.abs(shiftInLatitude) + Math.abs(shiftInLongitude)
                let multiplier = 2/totalShift
                shiftInLongitude = shiftInLongitude * multiplier
                shiftInLatitude = shiftInLatitude * multiplier

                var north1 = this.meterToLatitude(this.latitudeToMeter(firstTree.gps_latitude) + shiftInLatitude)
                var east1 = this.meterToLongitude(this.longitudeToMeter(firstTree.gps_longitude, firstTree.gps_latitude) - shiftInLongitude, firstTree.gps_latitude)

                var north2 = this.meterToLatitude(this.latitudeToMeter(firstTree.gps_latitude) - shiftInLatitude)
                var eash2 = this.meterToLongitude(this.longitudeToMeter(firstTree.gps_longitude, firstTree.gps_latitude) + shiftInLongitude, firstTree.gps_latitude)


                var south1 = this.meterToLatitude(this.latitudeToMeter(lastTree.gps_latitude) + shiftInLatitude)
                var west1 = this.meterToLongitude(this.longitudeToMeter(lastTree.gps_longitude, lastTree.gps_latitude) - shiftInLongitude, lastTree.gps_latitude)
                var south2 = this.meterToLatitude(this.latitudeToMeter(lastTree.gps_latitude) - shiftInLatitude)
                var west2 = this.meterToLongitude(this.longitudeToMeter(lastTree.gps_longitude, lastTree.gps_latitude) + shiftInLongitude, lastTree.gps_latitude)

                const flightPlanCoordinates = [
                    { lat: north1, lng: east1 },
                    { lat: north2, lng: eash2 },
                    { lat: south2, lng: west2 },
                    { lat: south1, lng: west1 },
                    { lat: north1, lng: east1 },
                ];
                sampleArea = new google.maps.Polyline({
                    path: flightPlanCoordinates,
                    geodesic: true,
                    strokeColor: "#FF0000",
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                    map: this.map,
                });

            } else {
                 sampleArea = new google.maps.Circle({
                    strokeColor: '#FF0000',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#FF0000',
                    fillOpacity: 0.35,
                    map: this.map,
                    center: {lat: sample.latitude, lng: sample.longitude},
                    radius: 5
                });
            }
            this.polyArray.push(sampleArea)
        });
    }

    latitudeToMeter(lat) {
        return 111320 * lat
    }

    meterToLatitude(meter) {
        return meter / 111320
    }

    longitudeToMeter(lng, lat) {
        return  (lng * 40075000 * Math.cos( lat )) / 360
    }

    meterToLongitude(meter, lat) {
        return (meter * 360) / (40075000 * Math.cos( lat ))
    }

    drawTrees(){

        const { google } = this.props;

        this.treeArray.forEach((t)=>{
            t.setMap(null);
        });
        this.treeArray = [];

        this.samples.forEach((sample) => {
            sample.trees[0].forEach((tree)=>{
                let treePolygon = new google.maps.Circle({
                    strokeColor: '#0000FF',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#00FF00',
                    fillOpacity: 0.35,
                    map: this.map,
                    center: this.getLatLngPair(sample, tree),
                    radius: 0.5
                });
                this.treeArray.push(treePolygon);
            });
        });

    }

    getLatLngPair(sample, tree) {
        const r_earth = 6378000;

        if (tree.gps_longitude !== undefined && tree.gps_latitude !== undefined) {
            return { lat: tree.gps_latitude, lng: tree.gps_longitude}
        }
        return {lat: sample.latitude + ((tree.altitude / r_earth) * (180 / Math.PI)),
            lng: sample.longitude + (tree.longitude / r_earth) * (180 / Math.PI) / Math.cos(sample.latitude * Math.PI/180)
        }
    }
o
    /**
     * @returns map options
     */
    options() {

        const { google } = this.props;

        return {
            center: new google.maps.LatLng(63.818742, 20.31),
            zoom: 5,
            zoomControl: true,
            fullscreenControl: false,
            mapTypeControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            streetViewControl: false,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },

            minZoom: 3
        };
    }

    /**
     * Add style to google style object
     * @param style
     * @param name
     * @returns {google.maps.StyledMapType}
     */
    style(style, name) {
        const { google } = this.props;
        return new google.maps.StyledMapType(style,
            { name: name });
    }

    /**
     * Add style to map
     * @param name
     * @param style
     */
    setType(name, style) {
        this.map.mapTypes.set(name, style);
    }



    addPolyLine(lat, lng) {
        var path = [

        ];
        for (var i = 0; i < lat.length; i++) {
            path.push({ lat: lat[i], lng: lng[i] });
        }

      /*  var flightPath = new google.maps.Polyline({
            path: path,
            geodesic: true,
            strokeColor: '#FF0000',
            strokeOpacity: 1.0,
            strokeWeight: 2,
            map: map
        });
*/
        //flightPath.setMap(map);
    }

    /**
     * Fly to coordinates, doesn't set zoom. Maybe should?
     * @param lat
     * @param lng
     */
    fly(lat, lng) {
        const { google } = this.props;

        this.map.setCenter(new google.maps.LatLng({lat: lat, lng: lng}));
    }

    /**
     * Remove all polygons
     * not in use if Search.js is rewritten
     */
    removeAllPoly() {

        for (let i = 0; i < this.polyArray.length; i++) {
            this.polyArray[i].setMap(null);
        }
        this.polyArray = [];
    }

    deleteCoordinatesListener(CRemove, CListenerUp, firstC, lastC) {

        const { google } = this.props;
        google.maps.event.removeListener(CRemove);
        google.maps.event.removeListener(CListenerUp);
        this.drawBox(firstC, lastC);
    }

    drawBox(corner1, corner2) {

        const { google } = this.props;
        var north, south, east, west;

        if (corner1.lat() > corner2.lat()) {
            north = corner1.lat();
            south = corner2.lat();
        }
        else {
            north = corner2.lat();
            south = corner1.lat();
        }

        if (corner1.lng() > corner2.lng()) {
            east = corner1.lng();
            west = corner2.lng();
        }
        else {
            east = corner2.lng();
            west = corner1.lng();
        }

        var bermudaTriangle = new google.maps.Polygon({
            paths: [{
                lat: north,
                lng: east
            }, {
                lat: north,
                lng: west
            }
                , {
                    lat: south,
                    lng: west
                }, {
                    lat: south,
                    lng: east
                }],
            strokeColor: 'orange',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: 'orange',
            fillOpacity: 0.10
        });
        bermudaTriangle.setMap(this.map);
        if (this.previousSelection != null) {
            this.previousSelection.setMap(null);
        }
        this.previousSelection = bermudaTriangle;

        setTimeout(function () {
            bermudaTriangle.fillOpacity = 0.05;
            bermudaTriangle.strokeOpacity = 0.4;
            this.previousSelection.setMap(null);
            bermudaTriangle.setMap(this.map);
        }.bind(this), 1500);
        setTimeout(function () { bermudaTriangle.setMap(null) }, 2500);

    }

  /*  deleteDrawList() {
        const { google } = this.props

        google.maps.event.removeListener(CListenerDown);
        google.maps.event.removeListener(CListenerUp);

    }

    setZoomListener() {
        this.map.addListener('zoom_changed', () => {

            let arr = this.props.main.lastValues.filter((alternative) => alternative != "imageBox")
            let prev = arr[arr.length - 1]

            if (this.map.getZoom() > 7 && prev != "profile" && prev != "album" && prev != "editImage") {
                this.props.appendZoomPoints(this.map.getBounds().getSouthWest().lng(), this.map.getBounds().getNorthEast().lng(), this.map.getBounds().getNorthEast().lat(), this.map.getBounds().getSouthWest().lat())
            }
        });
    }

    decodeLevels(encodedLevelsString) {
        var decodedLevels = [];

        for (var i = 0; i < encodedLevelsString.length; ++i) {
            var level = encodedLevelsString.charCodeAt(i) - 63;
            decodedLevels.push(level);
        }
        return decodedLevels;
    }
*/
    addPolyline(resource) {
    /*    var decodedPath = google.maps.geometry.encoding.decodePath(resource);
        //  decodedPath = google.maps.geometry.encoding.decodePath("uwpqGuu_zAiEsDrClMoGyC}BbOPjGhD~NtAn@gAvJKcCuQ`b@eDpCyCMqCgJyF_EwEhASbErBmAs@mCfBiApHhC|DyLQiCrDFrFqKrCkLzFl@uBoLzBeRrGpC_DiHl@mC~D`F");
        var decodedLevels = decodeLevels("BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB");

        var setRegion = new google.maps.Polyline({
            path: decodedPath,
            levels: decodedLevels,
            strokeColor: "#0000F0",
            strokeOpacity: 1.0,
            strokeWeight: 3,
            map: map
        });
        polylineArray.push(setRegion);
        return setRegion;
    }

    clearStrokeColor() {
        for (let i = 0; i < polylineArray.length; i++) {
            polylineArray[i].setOptions({ strokeColor: '#0000F0' });
        }*/
    }

    render() {

        return (
            <div ref="googleMap" style={{ width: window.innerWidth - 1050, height: window.innerHeight - 300}}/>
        )
    }
}